<template>
  <div>
    <div class="policy-hero">
      <div class="container">
        <h1>{{ $t('privacy.title') }}</h1>
        <p class="policy-hero__updated">{{ $t('privacy.lastUpdated') }}</p>
      </div>
    </div>

    <section class="policy-section">
      <div class="policy-content">

        <p class="policy-intro">{{ $t('privacy.intro') }}</p>

        <div class="policy-block">
          <h2>{{ $t('privacy.s1Title') }}</h2>
          <p>{{ $t('privacy.s1p1') }}</p>
          <div class="policy-card">
            <strong>{{ $t('privacy.s1CardName') }}</strong><br />
            {{ $t('privacy.s1CardWebsite') }}<br />
            {{ $t('privacy.s1CardContact') }} <a href="mailto:service@kordelo.com">service@kordelo.com</a>
          </div>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s2Title') }}</h2>
          <p>{{ $t('privacy.s2p1') }}</p>

          <h3>{{ $t('privacy.s2AccountTitle') }}</h3>
          <ul>
            <li v-for="(item, i) in $tm('privacy.s2AccountItems')" :key="i" v-html="item"></li>
          </ul>

          <h3>{{ $t('privacy.s2ContentTitle') }}</h3>
          <ul>
            <li v-for="(item, i) in $tm('privacy.s2ContentItems')" :key="i" v-html="item"></li>
          </ul>

          <h3>{{ $t('privacy.s2PaymentTitle') }}</h3>
          <ul>
            <li v-for="(item, i) in $tm('privacy.s2PaymentItems')" :key="i" v-html="item"></li>
          </ul>

          <h3>{{ $t('privacy.s2TechTitle') }}</h3>
          <ul>
            <li v-for="(item, i) in $tm('privacy.s2TechItems')" :key="i" v-html="item"></li>
          </ul>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s3Title') }}</h2>
          <table class="policy-table">
            <thead>
              <tr>
                <th v-for="(col, i) in $tm('privacy.s3Head')" :key="i">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in $tm('privacy.s3Rows')" :key="i">
                <td>{{ row[0] }}</td>
                <td>{{ row[1] }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s4Title') }}</h2>
          <ul>
            <li v-for="(item, i) in $tm('privacy.s4Items')" :key="i">{{ item }}</li>
          </ul>
          <p>{{ $t('privacy.s4p1') }}</p>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s5Title') }}</h2>
          <p v-html="$t('privacy.s5p1')"></p>
          <p>{{ $t('privacy.s5p2') }}</p>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s6Title') }}</h2>
          <p>{{ $t('privacy.s6p1') }}</p>
          <table class="policy-table">
            <thead>
              <tr>
                <th v-for="(col, i) in $tm('privacy.s6Head')" :key="i">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in $tm('privacy.s6Rows')" :key="i">
                <td v-html="row[0]"></td>
                <td>{{ row[1] }}</td>
                <td>{{ row[2] }}</td>
              </tr>
            </tbody>
          </table>
          <p>{{ $t('privacy.s6p2') }}</p>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s7Title') }}</h2>
          <p>{{ $t('privacy.s7p1') }}</p>
          <ul>
            <li v-for="(item, i) in $tm('privacy.s7Items')" :key="i" v-html="item"></li>
          </ul>
          <p>{{ $t('privacy.s7p2') }}</p>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s8Title') }}</h2>
          <p>{{ $t('privacy.s8p1') }}</p>
          <ul>
            <li v-for="(item, i) in $tm('privacy.s8Items')" :key="i" v-html="item"></li>
          </ul>
          <p v-html="$t('privacy.s8p2')"></p>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s9Title') }}</h2>
          <p>{{ $t('privacy.s9p1') }}</p>
          <p>{{ $t('privacy.s9p2') }}</p>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s10Title') }}</h2>
          <p>{{ $t('privacy.s10p1') }}</p>
          <div class="policy-card">
            <strong>{{ $t('privacy.s10CardName') }}</strong><br />
            {{ $t('privacy.s10CardWebsiteLabel') }} <a href="https://www.datatilsynet.no" target="_blank" rel="noopener noreferrer">{{ $t('privacy.s10CardWebsiteUrl') }}</a><br />
            {{ $t('privacy.s10CardPhone') }}
          </div>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s11Title') }}</h2>
          <p>{{ $t('privacy.s11p1') }}</p>
        </div>

        <div class="policy-block">
          <h2>{{ $t('privacy.s12Title') }}</h2>
          <p>{{ $t('privacy.s12p1') }}</p>
          <div class="policy-card">
            <strong>{{ $t('privacy.s12CardName') }}</strong><br />
            <a :href="`mailto:${$t('privacy.s12CardEmail')}`">{{ $t('privacy.s12CardEmail') }}</a>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'PrivacyPolicyPage',
  }
</script>

<style scoped>
.policy-hero {
  padding-top: 140px;
  padding-bottom: 60px;
  text-align: center;
  background: linear-gradient(180deg, rgba(91,141,184,0.07) 0%, transparent 100%);
}

.policy-hero h1 {
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  margin-bottom: 0.5rem;
}

.policy-hero__updated {
  font-size: 0.875rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
}

.policy-section {
  padding: 60px 2rem 100px;
}

.policy-content {
  max-width: 740px;
  margin: 0 auto;
}

.policy-intro {
  font-size: 1rem;
  line-height: 1.75;
  color: var(--text-muted);
  margin-bottom: 2.5rem;
  padding-bottom: 2.5rem;
  border-bottom: 1px solid var(--border);
}

.policy-block {
  margin-bottom: 2.5rem;
  padding-bottom: 2.5rem;
  border-bottom: 1px solid var(--border);
}

.policy-block:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.policy-block h2 {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 0.75rem;
}

.policy-block h3 {
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
}

.policy-block p {
  font-size: 0.9rem;
  line-height: 1.75;
  color: var(--text-muted);
  margin-bottom: 0.75rem;
}

.policy-block p:last-child {
  margin-bottom: 0;
}

.policy-block ul {
  margin: 0.5rem 0 0.75rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.policy-block li {
  font-size: 0.9rem;
  line-height: 1.65;
  color: var(--text-muted);
}

.policy-block a {
  color: var(--primary);
  text-decoration: none;
  font-weight: 500;
}

.policy-block a:hover {
  text-decoration: underline;
}

.policy-card {
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 1rem 1.25rem;
  font-size: 0.875rem;
  line-height: 1.75;
  color: var(--text);
  margin-top: 0.75rem;
}

.policy-card a {
  color: var(--primary);
  font-weight: 500;
  text-decoration: none;
}

.policy-card a:hover { text-decoration: underline; }

.policy-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

.policy-table th {
  text-align: left;
  font-weight: 700;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  padding: 0.6rem 0.75rem;
  background: var(--bg-alt);
  border: 1px solid var(--border);
}

.policy-table td {
  padding: 0.6rem 0.75rem;
  color: var(--text-muted);
  border: 1px solid var(--border);
  vertical-align: top;
  line-height: 1.5;
}

.policy-table tr:nth-child(even) td {
  background: rgba(0,0,0,0.015);
}

@media (max-width: 600px) {
  .policy-table { font-size: 0.8rem; }
  .policy-table th, .policy-table td { padding: 0.5rem; }
}
</style>
